<template>
  <div class="news-feed">
    <div v-if="newsFeed && limit">
      <ul class="news" v-for="(news, index) in newsFeed.slice(0, 2)" :key="index">
        <li class="news__feed"><i aria-hidden="true" class="icon icon-news"></i></li>
        <li class="news__feed">
          <a href="javascript:void(0)" class="news__feed--heading" @click="newsDetails">{{ $t(news.headline) }}</a>
          <span class="news__feed--date">{{ news.date }}</span>
          <p class="news__feed--description">{{ $t(news.description) | addEllipsesToLongText(80) }}</p>
        </li>
      </ul>
    </div>
    <div v-if="newsFeed && !limit">
      <ul class="news full-width" v-for="(news, index) in newsFeed" :key="index">
        <li class="news__feed"><i aria-hidden="true" class="icon icon-news"></i></li>
        <li class="news__feed">
          <h3 class="font--display-1">{{ $t(news.headline) }}</h3>
          <span class="news__feed--date">{{ news.date }}</span>
          <p class="news__feed--description">{{ $t(news.description) }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";
import { constants } from "@/lib/constants";

export default {
  name: "NewsFeed",
  data() {
    return {
      newsFeed: []
    };
  },
  props: {
    limit: {
      type: Boolean,
      required: false
    }
  },
  created() {
    this.newsFeed = constants.newsFeed.news;
  },
  computed: {
    //...mapGetters("newsFeed", ["newsFeed"])
  },
  methods: {
    newsDetails() {
      this.$router
        .push({
          name: "News"
        })
        .catch(() => {});
    }
  }
};
</script>
